<template>
  <button class="filter">
    <img
      :src="icon"
      alt="Filter button"
    >
  </button>
</template>

<script>
export default {
  name: 'filter-button',
  data() {
    return {
      icon: require('../../assets/icons/icon-filter.png'),
    };
  },
};
</script>

<style lang="scss" scoped>
.filter {
  display: inline-block;
  vertical-align: middle;
  width: 32px;
  height: 32px;
  font-size: 0;
  background: none;
  border: none;
  border-radius: 3px;
  cursor: pointer;
  position: relative;

  img {
    display: block;
    width: 14px;
    height: auto;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
}
</style>
